import { render, staticRenderFns } from "./ComuneForm.vue?vue&type=template&id=50a06114&scoped=true&"
import script from "./ComuneForm.vue?vue&type=script&lang=js&"
export * from "./ComuneForm.vue?vue&type=script&lang=js&"
import style0 from "./ComuneForm.vue?vue&type=style&index=0&id=50a06114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a06114",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
